import { Block } from "@components/block";
import { Button } from "@components/button";
import { Input } from "@components/input";
import { CustomSelect } from "@components/select";
import { useBoolState } from "@hooks/use-bool-state";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import styles from "./payouts.module.scss";
import { Config, DoubleText, Table } from "@components/table";
import { AdminPayoutModal } from "@components/admin-payout-modal";
import { useAdminPayOutOrders } from "@features/admin/payOut";
import { getFilterParamFromQuery } from "@helpers/utilities";
import { usePagination } from "@hooks/use-pagination";
import { AdminPayOutOrder, AdminPayPutOrdersRequest } from "@features/admin/payOut/api";
import { EllipsisText } from "@components/ellipsis-text";
import { formatRubles, formatUsdt } from "@helpers/format";
import { formatTime, formatDate } from "@helpers/date";
import { useUrlFilters } from "@hooks/useUrlFilters";
import { useWebSocket } from "@request/useWebsocket";
import { WebsocketUpdateType } from "@request/websocket";

export const adminAppelConfig: Config<AdminPayOutOrder> = [
  {
    label: "ID",
    source: "id",
    renderComponent: (data) => <EllipsisText text={data} copy />,
  },
  {
    label: "invid",
    source: "invid",
    renderComponent: (data) => <EllipsisText text={data} copy />,
  },
  {
    label: "Статус",
    source: "status",
  },
  {
    label: "Дата и время",
    source: "created_at_unix",
    renderComponent: (data) => (
      <DoubleText
        text={formatTime(new Date(data * 1000))}
        subText={formatDate(new Date(data * 1000))}
      />
    ),
  },
  {
    label: "Сумма",
    source: "sum",
    renderComponent: (data, item) => {
      return (
        <DoubleText
          text={formatUsdt(item.sum_usdt)}
          subText={formatRubles(data)}
        />
      );
    },
  },
  {
    label: "ID трейдера",
    source: "trader_email",
    renderComponent: (data) => {
      return <EllipsisText text={data} copy />;
    },
  },
  {
    label: "ID мерча",
    source: "merchant_email",
    renderComponent: (data) => {
      return <EllipsisText text={data} copy />;
    },
  },
];

export const AdminPayoutsPage = () => {
  const { control, handleSubmit } = useForm<AdminPayPutOrdersRequest>();
  const [isModalOpen, showModal, hideModal] = useBoolState(false);
  const [currentPayout, setCurrentPayout] = useState<AdminPayOutOrder>();
  const { page, limit, setPage, setLimit } = usePagination(100);
  const { setParams } = useUrlFilters();

  const { state, getAdminPayOutOrders } = useAdminPayOutOrders();

  const { lastMessage } = useWebSocket();

  useEffect(() => {
    if (lastMessage && lastMessage.type == WebsocketUpdateType.Withdrawal) {
    const status = getFilterParamFromQuery("status");
      getAdminPayOutOrders({ page, limit, status });
    }
  }, [lastMessage, limit, page]);
  useEffect(() => {
    const status = getFilterParamFromQuery("status");
    // const merchant_id = getFilterParamFromQuery("merchant_id");
    // const trader_id = getFilterParamFromQuery("trader_id");
    getAdminPayOutOrders({ limit, page, status });
  }, [getAdminPayOutOrders, limit, page]);

  const options = [
    { text: "Создана", value: "created" },
    { text: "Назначена на трейдера", value: "assigned_to_trader" },
    { text: "На рассмотрении", value: "under_review_by_support" },
    { text: "Завершена", value: "completed" },
    { text: "Открыт спор", value: "dispute_open" },
    { text: "Отмена нами", value: "cancelled_by_support" },
    { text: "Отмена трейдером", value: "cancelled_by_trader" },
    { text: "Отмена мерчантом", value: "cancelled_by_merchant" },
    { text: "Отмена для трейдера", value: "cancelled_but_awaiting_processing" },
  ];
  const onDealClick = (item: AdminPayOutOrder) => {
    showModal();
    setCurrentPayout(item);
  };
  const submitFilters = (data: AdminPayPutOrdersRequest) => {
    setParams(data);
    getAdminPayOutOrders({ ...data, limit: 100, page: 1 });
    setLimit(100);
  }
  return (
    <Block>
      <form className={styles.filter} onSubmit={handleSubmit(submitFilters)}>
        <Input name="oreder_id" control={control} placeholder="ID"></Input>
        <CustomSelect
          name="status"
          control={control}
          options={options}
          placeholder="Статусы"
          styles={{ width: "200px" }}
          clearable
        ></CustomSelect>
        <Input name="trader_email" control={control} placeholder="trader_email"></Input>
        <Input name="merchant_email" control={control} placeholder="merchant_email"></Input>
        <Button className={styles.btn}>Search</Button>
      </form>
      <Table
        config={adminAppelConfig}
        data={state.payOutOrders}
        loading={state.loading}
        setPage={setPage}
        setLimit={setLimit}
        page={page}
        limit={limit}
        limits={[100, 200, 300]}
        onRowClick={onDealClick}
        totalCount={state.count}
      ></Table>
      {currentPayout && (
        <AdminPayoutModal
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          data={currentPayout}
        />
      )}
    </Block>
  );
};
